'use strict';
import React, { Component } from 'react'

export default class HowProtect extends Component {

  constructor(props) {
    super(props);
  }

  render () {
    return (
      <div className="container">
        <div className="row text-justify">
          {
            this.props.locale == "es" ?
            <div className="col-md-12" style={{padding:25}}>
              <div className="row">
                <p style={{color:"red", textAlign:"center", fontWeight:"bold"}}>
                  Protegerse contra el fraude al consumidor
                </p>
                <p>
                  ¿Cómo te proteges de los estafadores que quieren robar tu 
                  dinero? Aprende sus trucos. Usa el sentido común. Y sigue 
                  los consejos aquí. Depende de usted si los estafadores ganan. 
                  Recuerde, cada estafa puede tener éxito o fracasar en 
                  función de si participa o no. Consejos para protegerse del 
                  fraude de transferencia bancaria.
                </p>
                <p style={{color:"red", fontWeight:"bold"}}>
                  Siempre:
                </p>
                <p>
                  <ul>
                    <li>Sepa con quién está tratando, especialmente si se trata de un premio no solicitado u oferta de regalo. </li>
                    <li>No confíe en un mensaje como: "¡Felicidades, acaba de ganar $ 1,000 en una lotería extranjera!"</li>
                    <li>Investigue una oferta para estar seguro de que es real.</li>
                    <li>Si suena demasiado bueno para ser verdad, probablemente no lo sea.</li>
                    <li>Recuerde que enviar dinero es como enviar efectivo. Cuando lo envías, se ha ido, no puedes recuperarlo.</li>
                  </ul>
                </p>
                <p style={{color:"red", fontWeight:"bold"}}>
                  Nunca:
                </p>
                <p>
                  <ul>
                    <li>Envíe dinero a alguien que no conoce - ¡Nunca!</li>
                    <li>Deposite un cheque de alguien que le diga que le envíe parte del dinero.</li>
                    <li>Envíe dinero a un familiar en crisis sin consultar primero la historia. Haga preguntas para verificar la identidad de la persona.</li>
                    <li>Envíe dinero para recibir dinero.</li>
                  </ul>
                </p>
              </div>
            </div> 
            
            :

            <div className="col-md-12" style={{padding:25}}>
              <div className="row">
                <p style={{color:"red", textAlign:"center", fontWeight:"bold"}}>
                  Protecting yourself against consumer fraud
                </p>
                <p>
                  How do you protect yourself from fraudsters who want to steal your money? Learn 
                  their tricks. Use common sense. And follow the tips here. It's up to you whether 
                  fraudsters win. Remember, every scam can succeed or fail based on whether or not 
                  you participate. Tips to protect yourself from wire transfer fraud.
                </p>
                <p style={{color:"red", fontWeight:"bold"}}>
                  Always:
                </p>
                <p>
                  <ul>
                    <li>Know who you are dealing with, especially if it's about an unsolicited prize or gift offer.  </li>
                    <li>Don't trust a message like: "Congratulations, you just won $1,000 in a foreign lottery!"</li>
                    <li>Research an offer to be sure it's real. </li>
                    <li>If it sounds too good to be true, it probably is.</li>
                    <li>Remember sending money is like sending cash. When you send it, it's gone - you can't get it back.</li>
                  </ul>
                </p>
                <p style={{color:"red", fontWeight:"bold"}}>
                  Never:
                </p>
                <p>
                  <ul>
                    <li>Send money to someone you don't know - Never!</li>
                    <li>Deposit a check from someone who tells you to send some of the money back to them.</li>
                    <li>Send money to a relative in crisis without checking out the story first. Ask questions to verify the person's identity.</li>
                    <li>Send money to receive money.</li>
                  </ul>
                </p>
              </div>
            </div> 
          }
        </div>
      </div>
    )
  }

}


// WEBPACK FOOTER //
// ./js/fraudAwareContent/howProtect.js